<template>
  <ul class="nav nav-pills justify-content-end mb-2">
    <li class="nav-item">
      <router-link
        :to="{ name: 'Submerchant Detail', params: { submerchantId } }"
        class="nav-link"
        exact
      >
        <i class="fa fa-info"></i>&nbsp; Details
      </router-link>
    </li>
    <!-- <li class="nav-item">
      <router-link :to="`/drivers/${submerchantId}/sales`" class="nav-link">
        <i class="fa fa-credit-card"></i>&nbsp; Transactions
      </router-link>
    </li>-->
    <li class="nav-item">
      <router-link
        :to="{ name: 'Submerchant Performance', params: { submerchantId } }"
        class="nav-link"
        exact
      >
        <i class="fa fa-area-chart"></i>&nbsp; Performance
      </router-link>
    </li>
  </ul>
</template>

<script>
export default {
  name: "SubmerchantNavigation",
  props: ["submerchantId"]
};
</script>